import clsx from "clsx";
import { useTranslation, TranslationProvider, useLocale } from "rujira.ui";
import { PageIntro } from "../common/components/PageIntro";
import { useIsMobile } from "../hooks/useBreakpoint";
import { CreditAccounts } from "../liquidate/CreditAccounts";
import { getStaticProductSeo, ProductSeoHelmet } from "../seo";

export function Liquidate() {
  const { locale } = useLocale();

  return (
    <TranslationProvider namespace="liquidate">
      <ProductSeoHelmet seo={getStaticProductSeo("/liquidate", locale)} />
      <LiquidateContent />
    </TranslationProvider>
  );
}

function LiquidateContent() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const Description = t("description");

  return (
    <>
      <div className="rujira__main rujira__main--gradient lending">
        <div className="rujira__inner--pad rujira__inner--pad-tight">
          <div className="rujira__inner">
            <h1 className="h1">{t("title")}</h1>
            <PageIntro className="fs-20 lh-28 mw-md-100 balance">
              {Description}
            </PageIntro>
            <div className="flex dir-c gap-2">
              <div className={clsx("relative mt-4", { "card p-3": !isMobile })}>
                <CreditAccounts />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
